const SERVICE = '/videos';

const MARK_VIDEO_AS_WATCHED = `${SERVICE}/watch`;

const videos = {
  MARK_VIDEO_AS_WATCHED,
};

export default videos;
